import { render, staticRenderFns } from "./SubEventsList.vue?vue&type=template&id=e475029c&"
import script from "./SubEventsList.vue?vue&type=script&lang=js&"
export * from "./SubEventsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports